import React from 'react';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import ListControls from './ListControls.js';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import styles from './Style.js';

const defaultImage = "https://firebasestorage.googleapis.com/v0/b/you-belong-1503433655652.appspot.com/o/shared%2FdefaultImage.jpg?alt=media&token=3c9122fd-92a2-470f-bf43-84b52fbfcff9";

class Image extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      image: defaultImage
    };
  }

  updateState = (url) => {
    if (url !== this.state.image) {
      this.setState({
        image: url
      });
    }
  }

  render() {
    const {classes} = this.props;
    if (this.props.object.gsImage !== undefined) {
      if (this.props.object.gsImage === "") {
        this.updateState(defaultImage);
      } else {
        this.updateState('https://admin.youbelong.church/centerchurch/image/'+this.props.object.gsImage);
      }
    } else if (this.props.object.imageSource !== undefined) {
      if (this.props.object.imageSource === "") {
        this.updateState(defaultImage);
      } else {
        this.updateState(this.props.object.imageSource);
      }
    }
    var idField = null;
    if (this.props.variant === "connection") {
      idField = <TextField className={classes.flexItemInner} type="text" name="id"
                  label="ID" multiline={true} value={this.props.object.id}
                  onChange={this.props.onIdChange}/>
    }
    return (
      <React.Fragment>
        <Card raised={true} className={classes.card}>
          <CardHeader
            title="Image"
            classes={{
              root: classes.cardHeader,
              action: classes.action,
            }}
            action={
              <ListControls onDelete={this.props.onDelete}
                onUp={this.props.onUp} onDown={this.props.onDown}/>
            }
          />
          <CardContent className={classes.cardContent}>
            <Card raised={true} className={classes.subcard}>
              <img className={classes.image} src={this.state.image} alt=""/>
            </Card>
          </CardContent>
          <CardActions>
            <div className={classes.flexItem}>
            {idField}
              <TextField className={classes.flexItemInner} type="text" name="gsImage"
                label="GS Image" multiline={true} value={this.props.object.gsImage}
                onChange={this.props.onGsImageChange}/>
              <TextField className={classes.flexItemInner} type="text" name="imageSource"
                label="Image Source" multiline={true} value={this.props.object.imageSource}
                onChange={this.props.onImageSourceChange}/>
            </div>
          </CardActions>
        </Card>
      </React.Fragment>
    );
  }

  static propTypes = {
    classes: PropTypes.object.isRequired,
  };
}

export default withStyles(styles)(Image);
